"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[234],{

/***/ 2234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);




var Partners = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var sectionTitle = data.sectionTitle, logos = data.logos, backgroundColor = data.backgroundColor;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("partners", "p-10", "py-[125px]", "bg-".concat(backgroundColor.value), "relative", "z-0", "site-container"),
        "data-theme": backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.title.toLowerCase(),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-center"),
            children: [
                sectionTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-caption", "font-sansRegular", "tracking-[0.14em]", "uppercase", "mb-5"),
                    children: sectionTitle
                }),
                logos && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("logos", "inline-flex", "justify-center", "py-5", "border-t", "bg-gray", "border-b", "border-[#C8C8C8]", "w-auto", "items-center", "opacity-100", "grid", "grid-cols-4", "max-w-[500px]", "mx-auto"),
                    children: logos.map(function(logo, idx) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mx-4", "col-span-2", "md:col-span-1"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("max-w-[100px]", "mx-auto", "my-2", "relative"),
                                children: [
                                    logo.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: logo.url,
                                        rel: "noreferrer",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "sr-only",
                                                children: [
                                                    "Link to ",
                                                    logo.url
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                photo: logo.image,
                                                width: 1200,
                                                layout: "static"
                                            })
                                        ]
                                    }),
                                    !logo.url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        photo: logo.image,
                                        width: 1200,
                                        layout: "intrinsic"
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Partners);


/***/ })

}]);